import { render, staticRenderFns } from "./BrandsSelect.vue?vue&type=template&id=b8171356&"
import script from "./BrandsSelect.vue?vue&type=script&lang=js&"
export * from "./BrandsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports